import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import i18n from 'i18next';

import { useGetProductClass } from '@/views/screens/Shipment';

import { routeFileSelector } from '../../../utilz/i18n';
import FormSelectBox from '../Inputs/FormSelectBox';

const NON_HAZARDOUS_OPTION = { label: 'Non Hazardous', value: 'N/A' };

const ShipmentProductClassSelector = ({
  placeholder = i18n.t('translation:default.fields.locationType.placeholder'),
  label = i18n.t('translation:default.fields.locationType.label'),
  rules = [],
  name,
  editMode,
  onChange = false,
  margin = 'mb-0',
  tooltip,
  isDefault = false,
  tabIndex,
  dataTestId,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data: options = [], isLoading } = useGetProductClass();

  const selectOptions = useMemo(() => {
    return [NON_HAZARDOUS_OPTION, ...options];
  }, [options]);

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        isDefault ? [{ label: t('translation:default.buttons.select'), value: '' }, ...selectOptions] : selectOptions
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      tooltip={tooltip}
      {...(onChange ? { onChange } : {})}
      tabIndex={tabIndex}
      dataTestId={dataTestId}
    />
  );
};

export default ShipmentProductClassSelector;
